/** 连连交易类型 */
export enum ELianlianTransactionType {
  /** 提现 */
  Withdrawal = 0,
  /** 服务费+税金退款 */
  servericeAndTaxRefund = 1,
  /** 服务费+税金收入 */
  servericeAndTaxIncome = 2,
}

export const lianlianTransactionType = {
  [ELianlianTransactionType.Withdrawal]: '提现',
  [ELianlianTransactionType.servericeAndTaxRefund]: '服务费+税金退款',
  [ELianlianTransactionType.servericeAndTaxIncome]: '服务费+税金收入',
};

/** 连连交易方向 */ // 收支类型和交易方向是一样的
export enum ELianlianTradingDirection {
  /** 支出 */
  expenditure = 1,
  /** 收入 */
  income = 0,

}

export const lianlianTradingDirection = {
  [ELianlianTradingDirection.expenditure]: '支出',
  [ELianlianTradingDirection.income]: '收入',
};

/** 连连资金流向 */
export enum EcapitalFlow {
  /** 出账 */
  DEBIT = 'DEBIT',
  /** 入账 */
  CREDIT = 'CREDIT',

}

export const lianlianCapitalFlow = {
  [EcapitalFlow.DEBIT]: '出账',
  [EcapitalFlow.CREDIT]: '入账',
};

/** 连连交易类型 */
export enum EfundType {
  /** 分账 */
  INNER_FUND_EXCHANGE = 0,
  /** 外部入账 */
  USER_TOPUP = 1,

}

export const lianlianFundType = {
  [EfundType.INNER_FUND_EXCHANGE]: '分账',
  [EfundType.USER_TOPUP]: '外部入账',
};

/** 连连记账方式 */
export enum EMethod {
  /** 入账*/
  recharge = 0,
  /** 提现 */
  cash = 1,
  /** 分账 */
  split = 4,
  /** 分账退款 */
  refound = 5,
  /** 代理手续费 */
  service = 8,

}

export const lianlianMethod = {
  [EMethod.recharge]: '入账',
  [EMethod.cash]: '提现',
  [EMethod.split]: '分账',
  [EMethod.refound]: '分账退款',
  [EMethod.service]: '代理手续费',
};

/** 绑定状态 */
export enum EBindStatus {
  /** 绑定中 */
  Binding = 0,
  /** 绑定成功 */
  Succeed = 1,
  /** 注销中 */
  Canceling = 2,
  /** 注销失败 */
  CancelFail = 3,
  /** 绑定失败 */
  BindFail = 4,
  /** 已解绑 */
  UnBind = 5,
}

export const lianlianBindStatus = {
  [EBindStatus.Binding]: '绑定中',
  [EBindStatus.Succeed]: '绑定成功',
  [EBindStatus.Canceling]: '注销中',
  [EBindStatus.CancelFail]: '注销失败',
  [EBindStatus.BindFail]: '绑定失败',
  [EBindStatus.UnBind]: '已解绑',
};

export const lianlianBindStatusStyle = {
  [EBindStatus.Binding]: 'warning',
  [EBindStatus.Succeed]: 'success',
  [EBindStatus.Canceling]: 'warning',
  [EBindStatus.CancelFail]: 'error',
  [EBindStatus.BindFail]: 'error',
  [EBindStatus.UnBind]: 'info',
};

// 付款方账单传参
export interface IPaymentBillPageParams {
  /** 连连Id */
   lianId: string;
  /** 分页 */
  page: number;
  /** 分页数量 */
  size: number;
  /** 账期开始时间 */
  dateAcctBegin?: string;
  /** 账期结束时间 */
  dateAcctEnd?: string;
  /** 出入账标识 */
  flagDc?: string;
  /** 账户号 */
  oidAcctno?: string;
  /** 交易流水号 */
  txnSeqno?: string;
  /** 财务流水号 */
  jnoAcct?: string;
  /** 交易类型 */
  txnType?: string;

}

// 付款方账单分页
export interface IPaymentBillPage {}

// 付款方交易记录传参
export interface IPaymentFundPageParams {
  /** 连连Id */
  lianId?: string;
  /** 分页 */
  page: number;
  /** 分页数量 */
  size: number;
  /** 开始时间 */
  startTime?: string;
  /** 结束时间 */
  endTime?: string;
  /** 付款方名称 */
  payerName?: string;
  /** 收款方名称 */
  payeeName?: string;
  /** 第三方流水号 */
  fundNo?: string;
  /** 通道方式 */
  channelId?: string;
  /** 记账方式 */
  fundType?: number;

}

/** 入账统计参数返回 */
export interface IPaymentFundCount{
  outMoney: number;
  inMoney: number;
}

// 付款方回单下载传参
export interface IPaymentReceiptPageParams {
  /** 连连Id */
  lianId?: string;
  /** 分页 */
  page: number;
  /** 分页数量 */
  size: number;
  /** 开始时间 */
  finishTimeStart?: string;
  /** 结束时间 */
  finishTimeEnd?: string;
  /** 记账方式 */
  inOutType?: number;

}

// 更换绑定手机号返回
export interface IPaymentChangePhone {
  /** 商户系统唯一交易流水号 */
  txn_seqno: number;
  /** 	授权令牌 */
  token: string;
}

